export const myAccountConfig = {
  company: 'Crufts Pet Insurance',
  referenceName: 'a Crufts',
  seoTitleSuffix: '| My Account | Crufts Pet Insurance',
  partnerIdName: 'Membership Number',
  partnerLoginInfo: 'For breeders',
  breederLoginInfo: 'For Crufts Pet Insurance Breeder Club members',
  vetLoginInfo: 'For veterinary practices',
  referAFriendUrl: 'https://clk.omgt1.com/?PID=56931&AID=2353495',
  petReferenceName: 'Dog',
  enableMarketingMaterials: false,
  enablePartnerLogin: false,
  showAddPetCard: true,
  termsReferenceName: 'Terms and Conditions',
  marketingReferenceName: 'marketing preferences',
  paymentDetailSupportMessage: false,
  enableUpdateMarketingPreferences: true,
  agriaAppReferenceName: 'Agria app',
  logoutRedirectUrl: '/',
} as const;
